import { AbstractMutableSetthfi6jds1k2h as AbstractMutableSet } from './AbstractMutableSet.mjs';
import { InternalHashMapmpvpylj0ut6l as InternalHashMap } from './InternalHashMap.mjs';
import { Unit_instance28fytmsmm6r23 as Unit_instance } from '../Unit.mjs';
import { KtMutableSetwuwn7k5m570a as KtMutableSet } from './Collections.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function init_kotlin_collections_HashSet(_this__u8e3s4) {
}
var HashSetClass;
function HashSet() {
  if (HashSetClass === VOID) {
    class $ extends AbstractMutableSet() {
      static ka(map) {
        var $this = this.g8();
        init_kotlin_collections_HashSet($this);
        $this.i3_1 = map;
        return $this;
      }
      static la() {
        return this.ka(InternalHashMap().h9());
      }
      static ma(elements) {
        var $this = this.ka(InternalHashMap().na(elements.v2()));
        var _iterator__ex2g4s = elements.u1();
        while (_iterator__ex2g4s.v1()) {
          var element = _iterator__ex2g4s.w1();
          $this.i3_1.c5(element, true);
        }
        return $this;
      }
      static oa(initialCapacity, loadFactor) {
        return this.ka(InternalHashMap().j9(initialCapacity, loadFactor));
      }
      static j3(initialCapacity) {
        return this.oa(initialCapacity, 1.0);
      }
      n2(element) {
        return this.i3_1.c5(element, true) == null;
      }
      f5() {
        this.i3_1.f5();
      }
      y2(element) {
        return this.i3_1.n9(element);
      }
      s1() {
        return this.i3_1.v2() === 0;
      }
      u1() {
        return this.i3_1.u9();
      }
      v2() {
        return this.i3_1.v2();
      }
    }
    initMetadataForClass($, 'HashSet', $.la, VOID, [AbstractMutableSet(), KtMutableSet()]);
    HashSetClass = $;
  }
  return HashSetClass;
}
//region block: exports
export {
  HashSet as HashSet2dzve9y63nf0v,
};
//endregion

//# sourceMappingURL=HashSet.mjs.map
